import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { formatNumber, formatPrice } from '@app/libs/format'
import getCDNImage from '@app/libs/getCDNImage'
import { InertiaLink } from '@inertiajs/inertia-react'
import Checkbox from '@mui/material/Checkbox'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import i18next from 'i18next'
import moment from 'moment'
import 'moment/dist/locale/vi'
import { useTranslation } from 'react-i18next'
import CustomChip from '../CustomChip/CustomChip'

const CustomGrid = styled(Grid)({
  position: 'relative',
  padding: '8px',
  backgroundColor: '#fff',
})

const CustomCard = styled(Grid)({
  boxShadow: '0.1rem 0.1rem 0.5rem 0.0rem rgb(0 0 0 / 30%)',
  height: '100%',
  position: 'relative',
  paadding: '5px',
  paddingBottom: '60px',
  overflow: 'hidden',
  borderRadius: '6px',
  transition: 'all 0.2s linear',
  '&:hover': {
    zIndex: '1',
    transform: 'scale(1.01)',
  },
})

const CustomName = styled(Typography)({
  fontWeight: 900,
  color: '#000000',
  fontFamily: 'Roboto !important',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
})

const CustomCheckbox = styled(Checkbox)({
  position: 'absolute',
  backgroundColor: '#ffffff80',
  borderBottomRightRadius: 3,
  backdropFilter: 'blur(2px)',
})

const CustomPremium = styled(Typography)({
  position: 'absolute',
  top: '15px',
  right: 0,
  zIndex: 1,
  display: 'inline-block',
  padding: '5px 10px 5px 24px',
  background: '#5c6bc0',
  color: '#FFFFFF',
  fontSize: '12px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  clipPath: 'polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 15% 50%, 0% 0%)',
})

const CustomMerchantName = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
})

const Customcategory = styled(Grid)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
})

const CustomGridCodes = styled(Grid)({
  position: 'absolute',
  bottom: '10px',
  minHeight: '55px',
  padding: '10px 10px 0',
})

const CustomAvailableCodes = styled(Typography)({
  fontFamily: 'Roboto !important',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  textAlign: 'right',
})

const CustomImage = styled('img')({
  width: '100%',
  borderRadius: '0.125rem',
  objectFit: 'cover',
  flexShrink: 0,
})

export default function GridCard({ data, handleChange, dataItems, handleCheck }) {
  const { t } = useTranslation()
  if (data && 0 === data.length) {
    return (
      <Grid container item pt={2} xs={12}>
        <Grid container item alignItems="center" justifyContent="center" xs={12}>
          <Typography variant="h5">{t('CART.NOT_DATA')}</Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container item sx={{ marginTop: '20px' }} xs={12}>
      {data.map((item, index) => (
        <CustomGrid item key={index} lg={3} md={6} xs={12}>
          <InertiaLink
            href={route('partner.vouchers', { id: item.id })}
            style={{ textDecoration: 'none', height: '100%' }}
          >
            <CustomCard container item direction="column" xs={12}>
              <CustomCheckbox
                checked={dataItems && dataItems.some((row) => row.id === item.id)}
                color="success"
                onClick={(event) => {
                  event.preventDefault()
                  handleCheck(item)
                  handleChange && handleChange(item)
                }}
              />
              {VOUCHER_TYPE.PREMIUM === item.type && <CustomPremium>{t('VOUCHERS.PREMIUM')}</CustomPremium>}
              <Grid container item xs={3}>
                <CustomImage src={getCDNImage(item.images[0].link, '400:200')} />
              </Grid>
              <Grid container item spacing={1} sx={{ padding: '5px 10px' }}>
                <Grid container item xs={12}>
                  <Grid item xs={7}>
                    <CustomName>{item.name}</CustomName>
                  </Grid>
                  <Grid container item justifyContent="flex-end" xs={5}>
                    {0 !== item.price && <Typography sx={{ fontWeight: 900 }}>{formatPrice(item.price)} </Typography>}
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <CustomMerchantName>{item.merchant_name}</CustomMerchantName>
                </Grid>
                <Customcategory container item spacing={1} xs={12}>
                  {(item.categories.slice(0, 2) || []).map((row, index) => (
                    <Grid item key={index}>
                      <CustomChip color="active" label={row.name} variant="outlined" />
                    </Grid>
                  ))}
                </Customcategory>
              </Grid>
              <CustomGridCodes container item justifyContent="space-between" xs={12}>
                <Grid item sx={{ textAlign: 'left' }} xs={5}>
                  {t('CART.END_IN')}
                  {moment
                    .duration(moment.utc(item.expired_date).local().diff(moment(), 'days', true), 'days')
                    .locale(i18next.language)
                    .humanize()}
                </Grid>
                <Grid container item justifyContent="flex-end" xs={6}>
                  <CustomAvailableCodes>
                    {formatNumber(item.available_codes)} {t('CART.CODE_AVAILABLE')}
                  </CustomAvailableCodes>
                </Grid>
              </CustomGridCodes>
            </CustomCard>
          </InertiaLink>
        </CustomGrid>
      ))}
    </Grid>
  )
}
